import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'sonner'
import App from './App.tsx'
import './index.css'
import './i18n'

// Import CSRF debug utility in development
if (import.meta.env.DEV) {
  import('./utils/debugCsrf').then(() => {
    console.log('CSRF Debug utility loaded. Run debugCsrf() in console to troubleshoot authentication.');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      richColors
      closeButton
      duration={6000}
    />
  </React.StrictMode>,
)
